"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderDetails = void 0;
const utils_monitoring_sonda_1 = __importDefault(require("@gcloud-npm/utils.monitoring.sonda"));
const utils_monitoring_get_uuid_1 = __importDefault(require("@gcloud-npm/utils.monitoring.get-uuid"));
const utils_fetch_1 = __importDefault(require("@gcloud-npm/utils.fetch"));
const node_build_process_build_environments_1 = require("@gcloud-npm/node.build-process.build-environments");
const utils_enums_environment_1 = require("@gcloud-npm/utils.enums.environment");
const utils_adabyron_make_up_telco_path_name_1 = require("@gcloud-npm/utils.adabyron.make-up-telco-path-name");
const utils_page_send_to_relogin_1 = __importDefault(require("@gcloud-npm/utils.page.send-to-relogin"));
const utils_common_get_ga_cookie_1 = __importDefault(require("@gcloud-npm/utils.common.get-ga-cookie"));
const METHOD = 'POST';
const getOrderDetails = ({ context, idFront = 'TC', build = false, version, onRedirect, data, token, logged, }) => {
    let HOST = 'https://www.movistar.es';
    let PATH = '/movistar-layer/api/open/order/tracking/v2/get-order-details';
    let EVENT_NAME = 'CLIENT.GET_OPEN_ORDER_DETAILS';
    const currentEnv = `${process.env.NEXT_PUBLIC_ENV_NAME}`;
    if (logged) {
        if (currentEnv === 'local' || currentEnv === 'qa' || currentEnv === 'qa_ssr') {
            HOST = 'https://layer.qa.col.movistar.es';
        }
        PATH = '/movistar-layer/api/client/order/tracking/v2/get-order-details';
        EVENT_NAME = 'CLIENT.GET_ORDER_DETAILS';
    }
    else {
        if (currentEnv === 'local' || currentEnv === 'qa' || currentEnv === 'qa_ssr') {
            HOST = 'https://layer.qa.col.movistar.es';
        }
        else {
            HOST = 'https://layer.col.movistar.es';
        }
    }
    const idRequest = (0, utils_monitoring_get_uuid_1.default)(idFront);
    const headers2Use = (0, node_build_process_build_environments_1.calculateHeaderParams)(build, utils_enums_environment_1.FAMILY_API.TELCO, context);
    const sonda = new utils_monitoring_sonda_1.default({
        eventName: EVENT_NAME,
        context,
        uniqueId: idRequest,
        origin: utils_adabyron_make_up_telco_path_name_1.PROCESS_NAME.CLIENT,
    });
    let ga = "";
    try {
        ga = (0, utils_common_get_ga_cookie_1.default)();
        data = Object.assign(Object.assign({}, data), { ga });
    }
    catch (e) {
        console.error(e);
    }
    let queryParams = [];
    let urlParamsToReplace = [];
    const URL_API = (0, utils_adabyron_make_up_telco_path_name_1.makeUpTelcoPathName)({
        path: PATH,
        version,
        idRequest,
        host: HOST,
        prefixToApply: '',
        queryParams,
        urlParamsToReplace,
    });
    const request = new utils_fetch_1.default({
        method: METHOD,
        endpoint: URL_API,
        headers: Object.assign(Object.assign({}, headers2Use), { 'Content-Type': 'application/json;charset=UTF-8', 'Accept': 'application/json', "X-Recaptcha-Token": token }),
        data,
        sonda,
        onRedirect: onRedirect || utils_page_send_to_relogin_1.default,
    });
    return request.makeRequest();
};
exports.getOrderDetails = getOrderDetails;
exports.default = exports.getOrderDetails;
//# sourceMappingURL=index.js.map